import { Navigate } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";
import AdminLayout from "@/admin/AdminLayout";
import PartnerEditor from "@/admin/PartnerEditor";

export default function AdminProfile() {
  const { user } = useAuth();

  if (user?.role !== "partner" || !user.partner_slug) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <AdminLayout
      title="Meu perfil"
      subtitle="Você está editando o perfil que aparece no diretório /politics/parceiros."
    >
      <PartnerEditor partnerSlug={user.partner_slug} asAdmin={false} />
    </AdminLayout>
  );
}
